import { useCallback } from "react";
import { useRecoilState } from "recoil";
import { OrderedCellRendererProps } from "../Grid/types";
import {
  NewReqActionCellButton,
  NewReqActionCellButtonGrid,
  NewReqActionCellGridWrapper,
  NewReqActionCellWrapper,
} from "./NewRequisition.styles";
import { convertNewReqTypeToForm } from "./Services/helpers";
import {
  currentEditDraftRequisition,
  currentNewRequisition,
} from "../../recoil/atoms";
import { GarbageCan } from "../../assets/iconComponents/GarbageCan";

export const NewReqActionDraftCell: React.FC<OrderedCellRendererProps> = ({
  data,
  setNewReqOpen,
  setDraftModal,
}) => {
  const convertedFormData = convertNewReqTypeToForm(data);
  const [, setDraftEditRequisition] = useRecoilState(
    currentEditDraftRequisition,
  );
  const [, setNewRequisition] = useRecoilState(currentNewRequisition);

  const handleEdit = useCallback(() => {
    setNewRequisition(convertedFormData);
    setDraftEditRequisition(data);
    setNewReqOpen?.(true);
  }, [convertedFormData]);

  return (
    <NewReqActionCellWrapper>
      <NewReqActionCellGridWrapper>
        <NewReqActionCellButtonGrid>
          <NewReqActionCellButton
            type="button"
            onClick={(e) => {
              e.preventDefault();
              handleEdit();
            }}
          >
            EDIT
          </NewReqActionCellButton>
          <NewReqActionCellButton
            type="button"
            onClick={(e) => {
              e.preventDefault();
              if (setDraftModal) {
                setNewRequisition(convertedFormData);
                setDraftModal("delete");
              }
            }}
          >
            <GarbageCan />
          </NewReqActionCellButton>
        </NewReqActionCellButtonGrid>
      </NewReqActionCellGridWrapper>
    </NewReqActionCellWrapper>
  );
};
